import { Context, Effect } from "effect";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { QueueAction, QueueMessageAction, QueueMessageInput } from "@workerstation/shared/resources/object-queue";
import type { QueueRecord, QueueTarget } from "./model.ts";
export interface QueueApiShape {
  readonly bindings: (workspaceId: string) => Effect.Effect<readonly QueueRecord[], ResourceFailure>;
  readonly send: (target: QueueTarget, message: typeof QueueMessageInput.Type) => Effect.Effect<void, ResourceFailure>;
  readonly action: (target: QueueTarget, action: typeof QueueAction.Type) => Effect.Effect<void, ResourceFailure>;
  readonly messageAction: (target: QueueTarget, messageId: string, action: typeof QueueMessageAction.Type) => Effect.Effect<void, ResourceFailure>;
}
export class QueueApi extends Context.Service<QueueApi, QueueApiShape>()("workerstation/frontend/QueueApi") {}
